import React from 'react';
import { UserProvider } from './UserContext';
import { UserCourseProvider } from './UserCourseContext';

const MasterAppProvider = ({ children }) => {
  return (
    <UserProvider>
      <UserCourseProvider>
        {children}
      </UserCourseProvider>
    </UserProvider>
  );
};

export default MasterAppProvider;